import React from 'react';

const Terms = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
            <div style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto', lineHeight: '1.6', background: "#fff" }}>
                <h1>Terms & Conditions</h1>
                <p><strong>Effective Date:</strong> [01-04-2024]</p>

                <h2>1. Company Information</h2>
                <p>
                    RIYMS Microfinance is a registered entity under the <strong>Ministry of Corporate Affairs (MCA), Government of India</strong>.
                    We are authorized to operate in the domain of <strong>loan distribution and financial services</strong>,
                    with a focus on providing accessible credit to underserved communities.
                </p>

                <h2>2. Eligibility</h2>
                <ul>
                    <li>You are at least 18 years of age.</li>
                    <li>You are legally capable of entering into a binding contract.</li>
                    <li>You are not barred from receiving financial services under applicable laws.</li>
                </ul>

                <h2>3. Our Services</h2>
                <p>
                    RIYMS offers microfinance-related services including:
                </p>
                <ul>
                    <li>Loan application and processing</li>
                    <li>Loan distribution and repayment tracking</li>
                    <li>Financial education and advisory</li>
                </ul>
                <p>
                    All services are subject to verification, eligibility checks, and approval in accordance with our policies and applicable laws.
                </p>

                <h2>4. Registration & Account Responsibility</h2>
                <ul>
                    <li>Provide accurate and complete personal and financial information.</li>
                    <li>Maintain the confidentiality of your login credentials.</li>
                    <li>Notify us immediately of any unauthorized use or security breach.</li>
                </ul>

                <h2>5. Loan Terms</h2>
                <p>
                    Loan details such as disbursal, interest rates, penalties, and repayment terms are governed by specific
                    <strong> Loan Agreements</strong>. Users must review and accept the agreement before proceeding.
                </p>

                <h2>6. Legal Compliance</h2>
                <p>
                    We comply with applicable laws and financial regulations laid out by the <strong>RBI, MCA</strong>, and other authorities.
                    We cooperate with legal entities and report any suspicious or fraudulent activities.
                </p>

                <h2>7. Limitation of Liability</h2>
                <ul>
                    <li>We are not responsible for financial loss due to user errors.</li>
                    <li>We are not liable for website or service outages.</li>
                    <li>We are not responsible for third-party misuse of user data outside our control.</li>
                </ul>

                <h2>8. Intellectual Property</h2>
                <p>
                    All content, branding, and design on this website are owned by RIYMS and protected under intellectual property laws.
                    Unauthorized use is strictly prohibited.
                </p>

                <h2>9. Termination</h2>
                <p>
                    We may suspend or terminate user access if there is:
                </p>
                <ul>
                    <li>A violation of these Terms</li>
                    <li>Submission of false information</li>
                    <li>Illegal or abusive activity</li>
                </ul>

                <h2>10. Changes to the Terms</h2>
                <p>
                    These Terms & Conditions may be updated at any time. The latest version will be published on this page.
                    Continued use of our services implies acceptance of the updated terms.
                </p>

                <h2>11. Contact</h2>
                <p>
                    For questions regarding these terms, please visit our <a href="/contact">Contact Us</a> page or email us at:
                    <strong> support@riyms.com</strong>
                </p>
            </div>
        </div>
    );
};

export default Terms;
